import Vue from 'vue';

Vue.use({
  install: (instance) => {
    instance.prototype.formatArrayOutput = (array = []) => array.length ? array.join(', ') : '-';
  }
});
